"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BUNDLE_WITH_MIXED_CURRENCY_RESOLUTION_CURRENCY = void 0;
exports.BUNDLE_WITH_MIXED_CURRENCY_RESOLUTION_CURRENCY = 0; // Currency.Euro
//# sourceMappingURL=currencies.js.map